import { motion } from "framer-motion";

const TOOLS = [
  { name: "Adobe Premiere Pro", tag: "Editing", img: "/media/tool-premiere.png" },
  { name: "Adobe After Effects", tag: "Motion & VFX", img: "/media/tool-aftereffects.png" },
  { name: "Adobe Photoshop", tag: "Graphics", img: "/media/tool-photoshop.png" },
];

export default function Tools() {
  return (
    <section className="relative pb-24 lg:pb-32" data-testid="tools-mastered-section">
      <div className="wrap">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7 }}
        >
          <p className="eyebrow mono-label text-[11px] text-zinc-400">Tools I&apos;ve mastered</p>
        </motion.div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-3">
          {TOOLS.map((t, i) => (
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`tool-card-${t.tag.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="sheen-card group flex items-center gap-5 rounded-3xl border border-white/8 bg-[#0E0E12] p-6 transition-colors duration-500 hover:border-white/20"
            >
              <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl border border-white/10 bg-[#16161D] p-3">
                <img src={t.img} alt={`${t.name} logo`} loading="lazy" className="h-full w-full object-contain" />
              </div>
              <div>
                <p className="font-display text-xl font-bold uppercase tracking-wide">{t.name}</p>
                <p className="mono-label mt-1 text-[10px] text-zinc-500">{t.tag}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
